// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"vy_a bhe_b bhe_ux"};